import {
  getReceiptKey,
  getReceiptsKey,
  useGetReceipt,
  useUpdateReceipt,
} from 'api-hooks/receipt';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import ReceiptForm from './components/form';

export type ReceiptViewParams = {
  id: string;
};

export default function ReceiptView(
  props: NavigationProps<NavigationRoutes.ReceiptsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetReceipt({
    id,
  });
  const { mutateAsync, error: errorMutate } = useUpdateReceipt();

  const receipt = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )}
          <ReceiptForm
            {...props}
            receipt={receipt}
            onSubmit={async (input, form) => {
              const result = await mutateAsync({
                body: input,
                id: receipt!.id,
              });

              queryClient.refetchQueries([getReceiptsKey()[0]]);
              queryClient.refetchQueries(getReceiptKey({ id: result.data.id }));

              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
